var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whatsapp-body"},[_c('a',{attrs:{"href":"https://web.whatsapp.com/send?phone=8618126135449&text=Hi%2C%20could%20you%20please%20send%20me%20the%20PDF%20catalog%3F","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{attrs:{"src":require("@/assets/images/WhatsApp.png"),"alt":""}})])])
}]

export { render, staticRenderFns }